// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__+wPdQ","container":"LoadingSpinner_container__F0FLi"};